<script type="text/javascript">
import { getIdFromURL } from 'vue-youtube-embed';

export default {
  computed: {
    getYoutubeUrl() {
      return getIdFromURL('https://www.youtube.com/watch?v=NfWU0Wiixuo');
    },
  },
};
</script>

<style lang="scss">
  @import "~styles/settings";

  .home-videos {
    background: $white;
    margin-bottom: 10px;

    &__content {
      padding: 15px 15px 10px;
    }


    &__header {
      font-size: 26px;
      line-height: 24px;
      padding: 19px 12px 5px;
      color: $black;
      box-shadow: 0 2px 12px 0 rgba(161, 172, 202, 0);
      display: flex;

      @include breakpoint($layout-breakpoint) {
        padding: 19px 12px 5px;
        font-size: 27px;
        line-height: 36px;
      }
    }

    &__line {
      height: 1px;
      background: $grey1;
      margin: 5px 13px 0;
    }

    &__note {
      margin: 5px 0;
      line-height: 1.2;
      font-size: 14px;

      &-link {
        @include clickable-item;
      }
    }
  }
</style>

<template>
  <div class="home-videos">
    <div class="home-videos__header">
      <div class="home-videos__header-title">
        How to Open an Account
      </div>
    </div>
    <div class="home-videos__line"></div>
    <div class="home-videos__content">
      <youtube
        class="home-videos__player"
        player-width="100%"
        :player-height="240"
        :video-id="getYoutubeUrl">

      </youtube>
      <div class="home-videos__note">
        For more information on how to trade on PredictIt, visit our <router-link :to="{name: 'HelpAndSupport'}" class="home-videos__note-link">Support</router-link> page.
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/home/home-old/home-videos.vue